import React, { useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import '../../../../css/profilecontent.css';
import JobBox from './boxes/JobBox';
import JobList from './JobList';

const ProfileContent = ({ jobs, setJobs }) => {
    const {
        toggleDropdown,
        setShowAddMedia,
        activeDropdown,
        setSelectedReview
    } = useOutletContext();

    const [activeJobMenuId, setActiveJobMenuId] = useState(null);

    const toggleJobOptionsMenu = (reviewId) => {
        setActiveJobMenuId(activeJobMenuId === reviewId ? null : reviewId);
    };

    return (
        <div className="container">
            <JobBox
                    jobs={jobs}
                    setJobs={setJobs}
                    activeDropdown={activeDropdown}
                    toggleDropdown={toggleDropdown}
                    activeJobMenuId={activeJobMenuId}
                    toggleJobOptionsMenu={toggleJobOptionsMenu}
                // toggleVisibility={toggleVisibility} // optional if adding visibility logic
                />

        </div >
    );
};

export default ProfileContent;
